export const pageNames = {
	taskLayout: 'Tasks',
	adjustmentLayout: 'Adjustment Layout',
	smartScreens: 'Smart Screens',
	smartScreensSem: 'Sem',
	smartScreens440gl: '440gl',
	smartScreensIndependence: 'Independence',
	reviewNotes: 'Review Notes',
	archiveTimeline: 'Archive Timeline',
	maps: 'Maps',
	engagementOverview: 'Engagement Overview',
	copyHub: 'Copy Hub',
	received: 'Received',
	external: 'External',
	contentUpdates: 'Content Updates',
	forms: 'Forms',
	sync: 'Sync',
	pspAccounts: 'Psp Accounts',
	documentOpen: 'Document Open',
	helixProjects: 'Helix Projects',
	helixProjectsV2: 'Helix Projects V2',
	analyzerConfiguration: 'Analyzer Configuration',
	engagement: 'Engagement',
	connections: 'Connections',
	financialStatements: 'Financial Statements',
	class: 'Class',
	account: 'Account',
	systemDiagnostics: 'System Diagnostics',
	createPackage: 'Create Package',
	requests: 'Requests',
	request: 'Request',
	activityFeed: 'Activity Feed',
	groupSummary: 'Group Summary',
	receiveInstructions: 'Receive Instructions',
	reports: 'Reports',
	reportGrid: 'Report Grid',
	buildSteps: 'Build Steps',
	localLandingPage: 'Local Landing Page',
	groupInstructions: 'Group Instructions',
	cookieSettings: 'Cookie Settings',
	manageTeam: 'Manage Team'
};

export const siteSections = {
	taskLayout: 'Tasks',
	adjustmentLayout: 'Adjustment Layout',
	smartScreens: 'Smart Screens',
	reviewNotes: 'Review Notes',
	archiveTimeline: 'Archive Timeline',
	dashboard: 'Dashboard',
	copyHub: 'Copy Hub',
	manageTeam: 'Manage Team',
	contentUpdates: 'Content Updates',
	documents: 'Documents',
	helixProjects: 'Helix Projects',
	connections: 'Connections',
	financialStatements: 'Financial Statements',
	leadSheet: 'Lead Sheet',
	systemDiagnostics: 'System Diagnostics',
	collaboration: 'Collaboration',
	activityFeed: 'Activity Feed',
	groupSummary: 'Group Summary',
	receiveInstructions: 'Receive Instructions',
	reports: 'Reports',
	buildSteps: 'Build Steps',
	localLandingPage: 'Local Landing Page',
	groupInstructions: 'Group Instructions',
	consent: 'Consent'
};
